/**
 * get routeName without language code at the end
 * remove last 8 characters (e.g. '-en-US' or '-pt-BR')
 */
export const getRouteNameWithoutLanguage = (
  routeName: string | null | undefined
): string => {
  if (!routeName) return 'unknown'

  // remove language code (usually 8 characters: -en-US, -pt-BR, etc.)
  return routeName.slice(0, -8) || 'unknown'
}
